import { useContext } from "react";

import { BoardContext, IBoardContext } from "./BoardContext";

export function useBoard(): IBoardContext {
  const context = useContext(BoardContext);
  if (!context) {
    throw new Error("useBoard must be used within a BoardProvider");
  }

  return context;
}
